import {CreateSlice} from 'base'
import {SetFilter, SetSearch, SetSort} from 'common/types'
import {
  CURRENT_PROJECTS_INITIAL_FILTER,
  CLOSED_PROJECTS_INITIAL_FILTER,
  ProjectsFilter,
} from '.'

export interface ProjectsSlice {
  currentProjectsFilter: ProjectsFilter
  currentProjectsSearch: string
  currentProjectsSort: string
  closedProjectsFilter: ProjectsFilter
  closedProjectsSort: string
  closedProjectsSearch: string
  isFinPowerOpen: boolean
  isCreateProjectOpen: boolean

  setCurrentProjectsFilter: SetFilter
  setCurrentProjectsSearch: SetSearch
  setCurrentProjectsSort: SetSort
  setClosedProjectsFilter: SetFilter
  setClosedProjectsSearch: SetSearch
  setClosedProjectsSort: SetSort
  setFinPowerOpen: (isFinPowerOpen: boolean) => void
  setCreateProjectOpen: (isCreateProjectOpen: boolean) => void
}

const createProjectsSlice: CreateSlice<ProjectsSlice> = (set) => ({
  currentProjectsFilter: CURRENT_PROJECTS_INITIAL_FILTER,
  currentProjectsSearch: '',
  currentProjectsSort: 'desc maturity',
  closedProjectsFilter: CLOSED_PROJECTS_INITIAL_FILTER,
  closedProjectsSearch: '',
  closedProjectsSort: 'desc maturity',
  isFinPowerOpen: false,
  isCreateProjectOpen: false,

  setCurrentProjectsFilter: (currentProjectsFilter) =>
    set(() => ({currentProjectsFilter})),
  setCurrentProjectsSearch: (currentProjectsSearch) =>
    set(() => ({currentProjectsSearch})),
  setCurrentProjectsSort: (currentProjectsSort) =>
    set(() => ({currentProjectsSort})),
  setClosedProjectsFilter: (closedProjectsFilter) =>
    set(() => ({closedProjectsFilter})),
  setClosedProjectsSearch: (closedProjectsSearch) =>
    set(() => ({closedProjectsSearch})),
  setClosedProjectsSort: (closedProjectsSort) =>
    set(() => ({closedProjectsSort})),
  setFinPowerOpen: (isFinPowerOpen) => set(() => ({isFinPowerOpen})),
  setCreateProjectOpen: (isCreateProjectOpen) =>
    set(() => ({isCreateProjectOpen})),
})

export default createProjectsSlice
